
import Vue from 'vue'
import { FETCH_VESSEL_PROFILE_QC } from '@/core/services/store/qc.module'
import ShipSideView from '@/view/pages/QC/components/ShipSideView.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AppButton from "@/components/AppButton.vue"

interface BayData {
    name: string
    containers: unknown[] // Adjust the type of containers
}

export default Vue.extend({
    components: {
        ShipComponent: ShipSideView,
        AppButton,
    },
    inject: ["showErrors", "showSuccess", "showWarning", "isStandalone"],
    data() {
        return {          
            loadingMessage: 'Please wait ...',
            loading: false,
            selectedContainerType: 'standard',
            mirrorMode: false,
            bayData: [
                {
                    name: 'Bay 01',
                    containers: []
                }
            ] as BayData[],
        }
    },
    computed: {
        ...mapGetters({
            vesselProfile: 'getQCVesselProfile',
            selectedHatchId: 'getQCSelectedVesselProfile',
            selectedHatchIndex: 'getSelectedHatchIndex',
            selectedHatchData: 'getSelectedQCHatchData'
        }),
        vesselProfileName() {
            return this.vesselProfile.vesselProfileName
        },
       
    },
    methods: {
        ...mapActions({
            setSelectedQCHatchData: 'setSelectedQCHatchData',
            fetchVesselProfile: FETCH_VESSEL_PROFILE_QC,           
            setIsLoading: 'setIsLoading'
        }),
        getIsLoading() {
            return  this.$store.state.isLoading
        },
        ...mapMutations({
        }),
        onRefresh() {
            this.fetchVesselProfile(this.$route.params.id || 1)
                .catch((error: any) => this.showSuccess(error.message))
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {
        this.fetchVesselProfile(this.$route.params.id || 1)
            .catch( (error: any) => console.error(error.message))





    }
})
